import React from "react";
import { useLanguage } from "../../Language";
import { useAccount } from "../../Account";
import { LS2PAC_Utils } from "@tlc/ls2pac/app/utils/Utils";
import PrintDialog from "./PrintDialog";
import { useGlobalConfig } from "../../GlobalConfig";

export default function AccountPrintSummaryDialog() {
  const { translate } = useLanguage();

  const { patron } = useAccount();
  const feesInCurrency = LS2PAC_Utils.convertPenniesToCurrency(patron.fees);

  const { globalSettings } = useGlobalConfig();

  const buildHtml = () => {
    let html = `
      <div>
      <h2 align="center">${translate("accountInformation")}</h2>
        <div>${patron.fullName ?? ""}</div>
      ${
        !globalSettings.hidePersonalInformation
          ? `
                <div>${patron.address1 ?? ""}</div>
                <div>${patron.address2 ?? ""}</div>
                <div>${patron.city ?? ""} ${patron.state ?? ""}, ${
              patron.zipcode ?? ""
            }</div>
                <div>${patron.country ?? ""}</div>
                <br>
                <div>${translate("exportData_phone")}: ${
              patron.phone ?? ""
            }</div>
                <div>${translate("exportData_email")}: ${
              patron.email ?? ""
            }</div>
                <br>
              `
          : ""
      }
        <div>${translate("exportData_libraryId")}: ${
      patron.patronId ?? ""
    }</div>
        <div>${translate("exportData_cardExpirationDate")}: ${
      patron.cardExpirationDateString ?? ""
    }</div>
        <div>${translate("exportData_status")}: ${patron.status ?? ""}</div>
        <br>
        <div>${translate("accountSummary")}:</div>
        <div>${translate("exportData_loanCount")}: ${
      patron.loanCount ?? ""
    }</div>
        <div>${translate("exportData_itemsOverdue")}: ${
      patron.itemsOverdue ?? ""
    }</div>
        <div>${translate("exportData_itemsLost")}: ${
      patron.lostCount ?? ""
    }</div>
        <div>${translate("exportData_pendingHolds")}: ${
      patron.pendingHolds ?? ""
    }</div>
        <div>${translate("exportData_arrivedHolds")}: ${
      patron.arrivedHolds ?? ""
    }</div>
        <div>${translate("exportData_fines")}: ${translate(
      "currency",
    )}${feesInCurrency}</div>
      </div>
      <br class="pagebreak">
    `;
    return html;
  };

  return (
    <React.Fragment>
      <PrintDialog
        buttonText={`${translate("print")} ${translate("accountSummary")}`}
        dialogTitle={translate("accountInformation")}
        htmlContent={buildHtml()}
      />
    </React.Fragment>
  );
}
